<div class="d-flex flex-column flex-md-row justify-content-between gap-2 pb-2">
    <div>
        <div class="fs-4 d-flex gap-1">
            <div>
                <i class="fa-regular fa-calendar-days"></i> {{formattedDate}}
            </div>
            <div class="d-flex gap-1">
                <span class="badge badge-secondary fs-5 p-1" *ngFor="let weekdayIndex of weekdayRange">
                    {{getWeekdayFromIndex(weekdayIndex)}}
                </span>
            </div>

        </div>
        <div class="h8">
            {{option.title}}, {{option.level}}
        </div>
        <div class="fs-4 fw-regular">
            {{option.location}}
        </div>
        <div *ngIf="filteredChildren.length">
            <ul class="m-0 py-0">
                <li class="fs-4" *ngFor="let child of filteredChildren">
                    {{child.from | date: 'dd.MM.yy HH:mm'}} - {{child.to | date: 'HH:mm'}}
                </li>
                <li style="list-style: none;" *ngIf="!showAll">
                    <button class="btn btn-sm btn-link p-0" (click)="showAll = true">
                        Alle {{childrenCount}} anzeigen
                        <i class="fa-solid fa-chevron-down"></i>
                    </button>
                </li>
                <li style="list-style: none;" *ngIf="showAll">
                    <button class="btn btn-sm btn-link p-0" (click)="showAll = false">
                        Weniger anzeigen
                        <i class="fa-solid fa-chevron-up"></i>
                    </button>
                </li>
            </ul>

        </div>
    </div>

    <div class="d-flex gap-2 justify-content-end align-items-start">
        <button class="btn btn-sm btn-outline-success" [ngClass]="{ 'bg-success text-light': isYes }"
            (click)="setAnswer(assignmentScheduleOptionAnswerEnum.yes)"
            [disabled]="assignmentScheduleStateService.isFullyDisabled | async">
            {{'assignmentSchedules.answers.yes' | transloco}}
        </button>

        <button class="btn btn-sm btn-outline-warning" [ngClass]="{ 'bg-warning text-light': isMaybe }"
            (click)="setAnswer(assignmentScheduleOptionAnswerEnum.maybe)"
            [disabled]="assignmentScheduleStateService.isFullyDisabled | async">
            {{'assignmentSchedules.answers.maybe' | transloco}}
        </button>

        <button class="btn btn-sm btn-outline-danger" [ngClass]="{ 'bg-danger text-light': isNo }"
            (click)="setAnswer(assignmentScheduleOptionAnswerEnum.no)"
            [disabled]="assignmentScheduleStateService.isFullyDisabled | async">
            {{'assignmentSchedules.answers.no' | transloco}}
        </button>
    </div>
</div>